import { render, staticRenderFns } from "./GroupProccess.vue?vue&type=template&id=198b1d60&"
import script from "./GroupProccess.vue?vue&type=script&setup=true&lang=js&"
export * from "./GroupProccess.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports